export enum CBTProgramWeekFourStep {
    HowDidTrackingYourEmotionsGoStep = 'how-did-tracking-your-emotions-go-last-week',
    WhatIsMindfulnessOfEmotionsStep = 'what-is-mindfulness-of-emotions',
    WhatDoesAwarenessLookLikeStep = 'what-does-awareness-look-like',
    HowDoEmotionsWorkStep = 'how-do-emotions-work',
    WhatDoesThisLookLikeStep = 'what-does-this-look-like',
    MindfulnessOfEmotionsExerciseStep = 'practicing-mindful-awareness',
    PainVsSufferingStep = 'pain-vs-suffering',
    JudgmentsStep = 'judgments',
    SummaryOfEmotionsStep = 'summary-of-emotions',
    NonJudgmentalAwarenessStep = 'non-judgmental-awareness',
}

export enum CBTProgramWeekFourSurvey {
    HowDidTrackingYourEmotionsGo = 'week-4-how-did-tracking-your-emotions-go',
    PracticeMindfulnessOfEmotions = 'week-4-practicing-mindfulness',
}
